import { useLanguage } from "@/context/LanguageProvider";

// Using public path for the logo image
const logoImage = "/saleem_care_logo.jpeg";

interface LogoProps {
  size?: "sm" | "md" | "lg";
  showText?: boolean;
  variant?: "icon" | "full";
  className?: string;
}

export function Logo({
  size = "md",
  showText = true,
  variant = "full",
  className = "",
}: LogoProps) {
  const { isRTL } = useLanguage();

  const sizeClasses = {
    sm: { icon: "w-6 h-6", text: "text-xs", gap: "gap-1.5" },
    md: { icon: "w-10 h-10", text: "text-sm", gap: "gap-2" },
    lg: { icon: "w-12 h-12", text: "text-base", gap: "gap-3" },
  };

  const iconSize = sizeClasses[size].icon;
  const textSize = sizeClasses[size].text;
  const gapSize = sizeClasses[size].gap;

  const LogoIcon = () => (
    <div
      className={`flex items-center justify-center ${iconSize} rounded-lg overflow-hidden flex-shrink-0`}
    >
      <img
        src={logoImage}
        alt="Saleem Care Logo"
        className="w-full h-full object-contain"
        style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
      />
    </div>
  );

  if (variant === "icon") {
    return <LogoIcon />;
  }

  return (
    <div className={`flex items-center ${gapSize} ${isRTL ? "flex-row-reverse" : ""} ${className}`}>
      <LogoIcon />
      {showText && (
        <div className={`flex items-center ${isRTL ? "text-right" : "text-left"}`}>
          <span className={`font-bold ${textSize} text-[#019587] leading-tight lowercase`}>
            saleem care
          </span>
        </div>
      )}
    </div>
  );
}
